import BasicDetails from './BasicDetails';

export default BasicDetails;
